import { POLICY_PATHS } from '~constants/policies';

import { flatMap, filterAndConcat } from './array';

const getFilterFunction = (policy) => ({ path }) => path.includes(policy);

export const getKDSPolicies = ({ roles }) => {
  const fullPolicies = flatMap(({ policies }) => policies, roles);
  return filterAndConcat(
    fullPolicies,
    Object.values(POLICY_PATHS).map((policy) => getFilterFunction(policy))
  )?.filter(({ actions }) => actions.some(({ active }) => active));
};

export const hasAccessToKds = (userPolicies, adminUser) =>
  userPolicies?.length > 0 && adminUser.storeIds.length > 0;

export const isAllowed = (requiredActions, allowedActions, policy) =>
  allowedActions?.some(
    ({ key, actions }) => key === policy && requiredActions.every((action) => actions.includes(action))
  );

export const envFeatureFlags = {
  development: '-dev',
  stage: '-stage',
  production: ''
};
